import axios from '@/core/axios';

import {
  MarketplacePayment,
  MarketplacePaymentImport,
  MarketplacePaymentImportsListOptions,
  MarketplacePaymentPayload
} from './marketplace-payment-imports.types';

export class MarketplacePaymentImportsService {
  async list(opts: MarketplacePaymentImportsListOptions = {}): Promise<MarketplacePaymentImport[]> {
    const resp = await axios.get<MarketplacePaymentImport[]>('/marketplace-payment-imports', {
      params: { marketplace_id: opts.marketplace_id }
    });
    return resp?.data;
  }

  async get(id: number): Promise<MarketplacePaymentImport> {
    const resp = await axios.get<MarketplacePaymentImport>(`/marketplace-payment-imports/${id}`);
    return resp?.data;
  }

  async destroy(id: number): Promise<void> {
    await axios.delete(`/marketplace-payment-imports/${id}`);
  }

  async updatePayment(id: number, payload: Partial<MarketplacePaymentPayload>): Promise<MarketplacePayment> {
    const resp = await axios.put<MarketplacePayment>(`/marketplace-payments/${id}`, {
      marketplace_payment: payload
    });
    return resp?.data;
  }
}

export const marketplacePaymentImportsService = new MarketplacePaymentImportsService();
